export default __webpack_public_path__ + "static/media/reoppongi_ai.b60eb465.png";